import { useState, useEffect } from 'react';

export const useRightSideBar = ({
  rightSideBarProp,
  onboardingState,
  requiresExcerpts,
  requiresCodes,
  projectID,
  isArchived = false
}) => {
    const [hasExcerpts, setHasExcerpts] = useState(onboardingState.hasExcerpts);
    const [hasCodes, setHasCodes] = useState(onboardingState.hasCodes);

    useEffect(() => {
        if (projectID !== null) {
            setHasExcerpts(false);
            setHasCodes(false);
        }
    }, [projectID]);

    useEffect(() => {
        if (onboardingState.hasExcerpts) {
            setHasExcerpts(true);
        }
        if (onboardingState.hasCodes) {
            setHasCodes(true);
        }
    }, [onboardingState.hasExcerpts, onboardingState.hasCodes]);

    if (isArchived) return false;
    if (!rightSideBarProp) return false;
    if (onboardingState.loaded && onboardingState.hasNoCodeableData) return false;
    if (requiresExcerpts && !hasExcerpts) return false;
    if (requiresCodes && !hasCodes) return false;

    return rightSideBarProp;
};
